import { IEnvironment } from './env.interface';
import { EnvironmentType } from '@rccl/telemetry-events';

const baseConfig: IEnvironment = {
  BRAND: 'royal',
  CHANNEL: 'web',
  LANGUAGE: 'en',
  APIGEE_APP_KEY: '',
  APIGEE_APP_KEY_GQL:'',
  LAUNCH_DARKLY_ENV_KEY: '',
  LAUNCH_DARKLY_SDK_KEY: '',
  ESL_APP_KEY: '',
  API_PATH: '',
  APIGEE_MICROSERVICE_PORT: 443,
  TEALIUM: {
    BRAND_CODE: 'gdp',
    SCRIPT_URL: 'https://tags.tiqcdn.com/utag/rccl/${TEALIUM_BRAND_CODE}/${TEALIUM_ENV}/utag.js',
    PLACEHOLDER_BRAND_CODE: '${TEALIUM_BRAND_CODE}',
    PLACEHOLDER_ENV: '${TEALIUM_ENV}',
  },
  ADRUM: {
    APP_KEY: 'AD-AAB-ACJ-XED'
  },
  TELEMETRY: {
    APP_ID: 'Web.GuestCheckin',
    APP_ENV: EnvironmentType.CLOUD_PROD,
    BATCH: {
      SIZE: 10,
      ENABLED: true
    },
    DEBUG: {
      ENABLED: false,
      VERBOSE: false,
      CONSOLE_COLLAPSED: false
    },
    TRACKING_URL: 'https://stg1.api.rccl.com/en/royal/web/v1/ee/telemetry/events',
    ENDPOINTS: [],
    DISABLED: false
  },
  WHITE_LIST_DOMAINS: [],
  ENDPOINTS: {

    /**
     * Endpoints definition to call travel document types list
     * @variable API_GET_VALID_TRAVEL_DOCUMENTS - covers the new implementation
     */
    API_GET_VALID_TRAVEL_DOCUMENTS:
      '/v1/guestReservation/guestInformation/validTravelDocuments',

    /************ EXPENSE ACCOUNT ***********/

    /************* SESSION EXTEND OR END *********/
    API_POST_GUEST_ACCOUNTS_LOGOUT: '/auth/json/sessions?_action=logout',
    API_MICROSERVICE_GUEST_END_SESSION: '/web/v2/guestCheckin/lifecycle/end',

    /************* MICROSERVICES ****************/
    API_MICROSERVICE_PROFILE_BOOKINGS:
      '/v1/profileBookings/enriched',
    API_MICROSERVICE_BEGIN_DETAILS:
      '/web/v2/guestCheckin/lifecycle/begin/details',
    API_MICROSERVICE_SAILING_INFORMATION_ENRICHED: '/v3/ships/voyages',
    API_MICROSERVICE_ENRICHED: '/enriched',
    API_MICROSERVICE_RETRIEVE_ONBOARD_PAYMENT:
      '/v1/guestCheckin/onboardPayments/grantees',
    API_MICROSERVICE_RETRIEVE_CARD_COUNTRY:
      '/web/v1/payments/bins',
    API_MICROSERVICE_SEARCH: '/search',
    API_MICROSERVICE_CREATE_UPDATE_ONBOARD_PAYMENT:
      '/v1/guestCheckin/onboardPayments',
    API_MICROSERVICE_SAVE_ONBOARD_PAYMENT: 'savePayment',
    API_MICROSERVICE_DELETE_AUTHORIZED_CONSENTS:
      '/web/v2/guestCheckin/authorizedConsents/invalidate',
    API_MICROSERVICE_RETRIEVE_TRAVEL_QUESTIONNAIRE:
      '/v2/guestCheckin/authorizedConsents/searches/questionnaire',
    API_MICROSERVICE_CREATE_UPDATE_TRAVEL_QUESTIONNAIRE:
      '/v2/guestCheckin/authorizedConsents/questionnaire',
    API_MICROSERVICE_RETRIEVE_AUTHORIZED_CONSENTS:
      '/v2/guestCheckin/authorizedConsents/searches/authorizedConsents/all',
    API_MICROSERVICE_CREATE_UPDATE_AUTHORIZED_CONSENTS:
      '/v2/guestCheckin/authorizedConsents',
    API_MICROSERVICE_ARRIVAL_APPOINTMENTS:
      '/web/v1/guestCheckin/arrivalAppointments',
    API_MICROSERVICE_ARRIVAL_INVENTORY: '/arrivalAppointmentInventory',
    API_MICROSERVICE_BOARDINGPASS: '/web/v2/guestCheckin/boardingPasses',
    API_MICROSERVICE_RETRIEVE_CHECKIN_STATUS: '/v2/guestCheckin/statuses',
    API_GOVERNANCE_CONTENT: '/web/v1/core/governance/content',
    API_HEALTH_CENTER_PROTOCOLS: '/web/v1/core/governance/content/healthcenter',
    API_MICROSERVICE_CREATE_UPDATE_GUEST_INFORMATION: '/v1/guestReservation/guestInformation',
    API_MICROSERVICE_POST_SURVEY:'/v1/guestReservation/guestInformation/passengerSurvey',
    API_MICROSERVICE_GET_SECURITY_PHOTO_LIST: '/v1/guestCheckin/photo/list',
    API_MICROSERVICE_POST_SECURITY_PHOTO: '/v1/guestCheckin/photo/encoded',
    API_MICROSERVICE_POST_UPDATE_SECURITY_PHOTO:'/v1/guestCheckin/photo/encoded',
    API_MICROSERVICE_GET_PERSONAL_DETAIL_CONTENT:'/v1/content-services/content/olci',
    API_MICROSERVICE_POST_VALIDATE_LOYALTY: '/v1/guestCheckin/loyalty/validate',
    API_MICROSERVICE_POST_RETRIEVE_CRUISE_SURVEY: '/v1/guestAccounts/cruiseSurvey/retrieveCruiseSurvey',
    API_MICROSERVICE_POST_SAVE_CRUISE_SURVEY: '/v1/guestAccounts/cruiseSurvey/saveCruiseSurvey',
    API_MICROSERVICE_GET_COUNTRIES: '/v2/generics/countries',
  },
  ADVERTISEMENT: {
    BOARDING_PASS_PAGEID: '2209'
  },
  LOADER: ''
};

function isObject(item: any) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

export default baseConfig;

export function mergeDeep(target: any, ...sources: any): any {
  if (!sources.length) { return target; }
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) { Object.assign(target, { [key]: {} }); }
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }
  return mergeDeep(target, ...sources);
}